import { createSlice } from '@reduxjs/toolkit';
import {
  fetchPaintForm,
  fetchViewPaintForm,
  paintHistory,
  UpdatePaintFlowStatus,
  fetchPaintReport,
  fetchPaintInsulationData,
  listThermalInsulation,
  viewThermalInsulation,
  getHistoryThermalInsulation,
  deletePaintInspection,
  fetchPaintDashboard,
} from './paintThunk';

const initialState = {
  paintlist: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  paintview: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  updateFlowStatus: {
    loading: false,
    success: false,
    error: null,
  },
  paintHistory: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  paintReport: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  paintInsulation: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  listThormalInsulation: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  viewThormalInsulation: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  historyThormalInsulation: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  deletePaint: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  paintDashboard: {
    loading: false,
    success: false,
    error: null,
    data: null,
    isFiltered: false,
  },
  // Add filters state
  // filters: {
  //   date: '',
  //   shift: '',
  //   shellType: '',
  // },
  filters: {
    dateFrom: '',
    dateTo: '',
    shift: '',
    shellType: '',
  },
};

const paintSlice = createSlice({
  name: 'paint',
  initialState,
  reducers: {
    // Add filter reducers
    setDateFromFilter: (state, action) => {
      state.filters.dateFrom = action.payload;
    },
    setDateToFilter: (state, action) => {
      state.filters.dateTo = action.payload;
    },
    setShiftFilter: (state, action) => {
      state.filters.shift = action.payload;
    },
    setShellTypeFilter: (state, action) => {
      state.filters.shellType = action.payload;
    },
    resetFilters: (state) => {
      state.filters = {
        dateFrom: '',
        dateTo: '',
        shift: '',
        shellType: '',
      };
    },
    resetPaintDashboard: (state) => {
      state.paintDashboard = {
        loading: false,
        success: false,
        error: null,
        data: null,
        isFiltered: false,
      };
    },
    // Existing reducers
    resetStoreRoofPrecelling: (state) => {
      state.storeRoofPrecelling = {
        loading: false,
        success: false,
        error: null,
        data: null,
      };
    },
    resetUpdateFlowStatus: (state) => {
      state.updateFlowStatus = {
        loading: false,
        success: false,
        error: null,
        data: null,
      };
    },
    clearRoofPrecellingHistory: (state) => {
      state.roofPrecellingHistory = {
        loading: false,
        success: false,
        error: null,
        data: null,
      };
    },
    resetRoofPrecellingView: (state) => {
      state.roofPrecellingViewData = {
        loading: false,
        success: false,
        error: null,
        data: null,
      };
    },
    getEleFinalQualityInspectionList: (state) => {
      state.getEleFinalQualityInspectionList = {
        loading: false,
        success: false,
        error: null,
        data: [],
      };
    },
    clearFinalQualityParams: (state) => {
      state.eleqcParams = {
        loading: false,
        success: false,
        error: null,
        data: null,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPaintForm.pending, (state) => {
        state.paintlist.loading = true;
        state.paintlist.error = null;
      })
      .addCase(fetchPaintForm.fulfilled, (state, action) => {
        state.paintlist.loading = false;
        state.paintlist.data = action.payload;
      })
      .addCase(fetchPaintForm.rejected, (state, action) => {
        state.paintlist.loading = false;
        state.paintlist.error = action.payload || 'Failed to fetch stage one params';
      })
      .addCase(fetchPaintReport.pending, (state) => {
        state.paintReport.loading = true;
        state.paintReport.error = null;
      })
      .addCase(fetchPaintReport.fulfilled, (state, action) => {
        state.paintReport.loading = false;
        state.paintReport.data = action.payload;
      })
      .addCase(fetchPaintReport.rejected, (state, action) => {
        state.paintReport.loading = false;
        state.paintReport.error = action.payload || 'Failed to fetch report data';
      })
      .addCase(fetchViewPaintForm.pending, (state) => {
        state.paintview.loading = true;
        state.paintview.error = null;
      })
      .addCase(fetchViewPaintForm.fulfilled, (state, action) => {
        state.paintview.loading = false;
        state.paintview.data = action.payload;
      })
      .addCase(fetchViewPaintForm.rejected, (state, action) => {
        state.paintview.loading = false;
        state.paintview.error = action.payload || 'Failed to fetch stage one params';
      })
      .addCase(UpdatePaintFlowStatus.pending, (state) => {
        state.updateFlowStatus.loading = true;
        state.updateFlowStatus.error = null;
      })
      .addCase(UpdatePaintFlowStatus.fulfilled, (state) => {
        state.updateFlowStatus.loading = false;
        state.updateFlowStatus.success = true;
      })
      .addCase(UpdatePaintFlowStatus.rejected, (state, action) => {
        state.updateFlowStatus.loading = false;
        state.updateFlowStatus.error = action.payload || 'Failed to update status';
      })
      .addCase(fetchPaintInsulationData.pending, (state) => {
        state.paintInsulation.loading = true;
        state.paintInsulation.error = null;
      })
      .addCase(fetchPaintInsulationData.fulfilled, (state, action) => {
        state.paintInsulation.loading = false;
        state.paintInsulation.data = action.payload;
      })
      .addCase(fetchPaintInsulationData.rejected, (state, action) => {
        state.paintInsulation.loading = false;
        state.paintInsulation.error = action.payload || 'Failed to fetch report data';
      })
      .addCase(paintHistory.pending, (state) => {
        state.paintHistory.loading = true;
        state.paintHistory.error = null;
      })
      .addCase(paintHistory.fulfilled, (state, action) => {
        state.paintHistory.loading = false;
        state.paintHistory.success = true;
        state.paintHistory.data = action.payload;
      })
      .addCase(paintHistory.rejected, (state, action) => {
        state.paintHistory.loading = false;
        state.paintHistory.error = action.payload || 'Failed to get paint history';
      })
      .addCase(deletePaintInspection.pending, (state) => {
        state.deletePaint.loading = true;
        state.deletePaint.error = null;
      })
      .addCase(deletePaintInspection.fulfilled, (state, action) => {
        state.deletePaint.loading = false;
        state.deletePaint.success = true;
        state.deletePaint.data = action.payload;
      })
      .addCase(deletePaintInspection.rejected, (state, action) => {
        state.deletePaint.loading = false;
        state.deletePaint.error = action.payload || 'Failed to get paint history';
      })
      .addCase(listThermalInsulation.pending, (state) => {
        state.listThormalInsulation.loading = true;
        state.listThormalInsulation.error = null;
      })
      .addCase(listThermalInsulation.fulfilled, (state, action) => {
        state.listThormalInsulation.loading = false;
        state.listThormalInsulation.data = action.payload;
      })
      .addCase(listThermalInsulation.rejected, (state, action) => {
        state.listThormalInsulation.loading = false;
        state.listThormalInsulation.error =
          action.payload || 'Failed to fetch list thormal insulation';
      })
      .addCase(viewThermalInsulation.pending, (state) => {
        state.viewThormalInsulation.loading = true;
        state.viewThormalInsulation.error = null;
      })
      .addCase(viewThermalInsulation.fulfilled, (state, action) => {
        state.viewThormalInsulation.loading = false;
        state.viewThormalInsulation.data = action.payload;
      })
      .addCase(viewThermalInsulation.rejected, (state, action) => {
        state.viewThormalInsulation.loading = false;
        state.viewThormalInsulation.error =
          action.payload || 'Failed to fetch view thormal insulation';
      })
      .addCase(getHistoryThermalInsulation.pending, (state) => {
        state.historyThormalInsulation.loading = true;
        state.historyThormalInsulation.error = null;
      })
      .addCase(getHistoryThermalInsulation.fulfilled, (state, action) => {
        state.historyThormalInsulation.loading = false;
        state.historyThormalInsulation.data = action.payload;
      })
      .addCase(getHistoryThermalInsulation.rejected, (state, action) => {
        state.historyThormalInsulation.loading = false;
        state.historyThormalInsulation.error =
          action.payload || 'Failed to fetch history thormal insulation';
      })
      // Paint Dashboard Cases
      .addCase(fetchPaintDashboard.pending, (state) => {
        state.paintDashboard.loading = true;
        state.paintDashboard.error = null;
        state.paintDashboard.success = false;
        state.paintDashboard.isFiltered = false;
      })
      .addCase(fetchPaintDashboard.fulfilled, (state, action) => {
        state.paintDashboard.loading = false;
        state.paintDashboard.success = true;
        state.paintDashboard.data = action.payload;
        state.paintDashboard.isFiltered = false;
      })
      .addCase(fetchPaintDashboard.rejected, (state, action) => {
        state.paintDashboard.loading = false;
        state.paintDashboard.success = false;
        state.paintDashboard.error = action.payload || 'Failed to fetch paint dashboard data';
        state.paintDashboard.isFiltered = false;
      });
  },
});

// Export all actions
export const {
  resetStoreRoofPrecelling,
  resetUpdateFlowStatus,
  clearRoofPrecellingHistory,
  resetRoofPrecellingView,
  getEleFinalQualityInspectionList,
  clearFinalQualityParams,
  resetPaintDashboard,
  // setDateFilter,
  setDateFromFilter,
  setDateToFilter,
  setShiftFilter,
  setShellTypeFilter,
  resetFilters,
} = paintSlice.actions;

export default paintSlice.reducer;
